import React from 'react';
import { useState } from 'react';
import Rodal from 'rodal';

type DeleteTransferProcessModalProps = {
  show: boolean,
  onDelete: () => Promise<void>
  onClose: () => void
}

const DeleteTransferProcessModal = ({ show, onDelete, onClose }: DeleteTransferProcessModalProps) => {
  const [loading, setLoading] = useState(false);

  const handleDeleteTransferProcess = () => {
    setLoading(true);

    onDelete().finally(() => setLoading(false))
  }

  return (
    <Rodal
      closeOnEsc
      width={600}
      height={300}
      visible={show}
      onClose={onClose}
    >
      <div className="d-flex flex-column h-100">
        <div className="modal-header">
          <div className="text-center">
            <h2>Remover processo de transferência.</h2>
          </div>
        </div>
        <div className="modal-body">
          Deseja remover o processo de transferência ? Essa ação não poderá ser desfeita.
        </div>
        <div className="modal-footer">
          <button
            type="button"
            disabled={loading}
            onClick={onClose}
            className="btn-primary btn blue"
          >
            Cancelar
          </button>
          <button
            type="button"
            disabled={loading}
            onClick={handleDeleteTransferProcess}
            className="btn-danger btn blue"
          >
            Deletar
          </button>
        </div>
      </div>
    </Rodal>
  )
}

export default DeleteTransferProcessModal;
